var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClearCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4859 19.8226C14.2726 19.8226 14.0699 19.7372 13.9206 19.5879L10.9019 16.5692C10.5926 16.2599 10.5926 15.7479 10.9019 15.4386C11.2113 15.1292 11.7233 15.1292 12.0326 15.4386L14.4859 17.8919L19.9686 12.4092C20.2779 12.0999 20.7899 12.0999 21.0993 12.4092C21.4086 12.7186 21.4086 13.2306 21.0993 13.5399L15.0513 19.5879C14.9019 19.7372 14.6993 19.8226 14.4859 19.8226Z",
    fill: "#4E525C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClearCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/clear-check.cf0d19e3d399ca98259e3c462f2af351.svg";